module.exports = __webpack_public_path__ + "img/Fb-UIA-cn.555c1ea9.png";